import axios from 'axios';
import { URL_CERBERUS } from '../../config/keys';


export type Team = {
	id: number,
	name: string
	users: number[]
}

type PostTeam = Omit<Team, 'id'>;
type PutTeam = Partial<PostTeam>;

export async function getTeams(): Promise<Team[]> {
	return axios.get(`${URL_CERBERUS}/api/v1/auth/teams`).then(res => res.data);
}

export async function postTeam(team: PostTeam): Promise<number> {
	return axios.post(`${URL_CERBERUS}/api/v1/auth/teams`, team).then(res => res.data);
}

export async function putTeam(id: number, team: PutTeam): Promise<void> {
	return axios.put(`${URL_CERBERUS}/api/v1/auth/teams/${id}`, team).then(res => res.data);
}

export async function deleteTeam(id: number): Promise<void> {
	return axios.delete(`${URL_CERBERUS}/api/v1/auth/teams/${id}`).then(res => res.data);
}